import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';
import Link from "@mui/material/Link";

import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import Page from "../../layout/Page";
import documentoPDF from "../../assets/pdf/Guía de Uso del Sistema de Gestión de Expedientes.pdf";
const BoxDescarga = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 4),
  border: 1,
  borderRadius: 3,
  color: "#fff",
  display: "flex",
  flexDirection: "row",
  //justifyContent: "space-around"
}));

const Inicio = () => {
  const breadcrumbs = [{ nombre: "Inicio", ruta: "/" }];
  return (
    <Page breadcrumbs={breadcrumbs}>
      <Box sx={{ backgroundColor: "#D8DBE0", pl: 2, pr: 2, pt: 4, pb: 4 }} >
        <Typography variant="titulo" paragraph>
          <b>Recordamos:</b>
        </Typography>
        <Box pl={2}>
          <Typography variant="cuerpo" paragraph>
            La definición de orgánicas, los cambios de organismos y la asignación de usuarios en los diferentes organismos, se reciben en la cuenta de mail: <b>datosbdu@entrerios.gov.ar</b>
          </Typography>
          <Typography variant="cuerpo" paragraph>
            Los requerimientos en cuanto a la definición de temáticas se reciben en la cuenta de mail: <b>consultaexpediente@entrerios.gov.ar</b>
          </Typography>
          <Typography variant="cuerpo" paragraph>
            Las solicitudes de alta de personas jurídicas se reciben en la cuenta de mail: <b>dipjentrerios@entrerios.gov.ar</b>.
          </Typography>
          <Typography variant="cuerpo" paragraph>
            Y los requerimientos referidos a las funcionalidades del sistema e inconvenientes que se presenten con los expedientes/trámites internos en la dirección de mail: <b>sistematramites@entrerios.gov.ar</b>.
          </Typography>
        </Box>
      </Box>
      <br></br>

      <Grid container spacing={2} sx={{ display: "flex", alignItems: "stretch" }}>
        
        {/* RECTÁNGULO VERDE */}
        <Grid item md={6} xs={12} sx={{ display: "flex" }}>
          <BoxDescarga 
            sx={{ 
              backgroundColor: "#799F4F", 
              display: "flex", 
              flexDirection: "column", 
              p: 3,
              pt: 4,          // Altura de inicio controlada para el texto
              height: "100%", 
              width: "100%",
              position: "relative" // Nos permite posicionar el icono de descarga de forma absoluta si es necesario
            }}
          >
            {/* Ícono absoluto a la izquierda para que no empuje el bloque de texto hacia abajo */}
            <Box sx={{ position: "absolute", top: 75, left: 16 }}>
              <SimCardDownloadOutlinedIcon sx={{ fontSize:60, color: "#fff" }} />
            </Box>
            
            {/* Contenedor del Texto y Link */}
            <Box 
              sx={{ 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                gap: 6,
                mt: 0 // Pequeño margen para alinearse simétricamente con el bloque azul
              }}
            >
              <Typography variant="cuerpo" color="#fff" sx={{ textAlign: "center" }}>
                Guía de uso del Sistema de Gestión de Expedientes
              </Typography>
              
              <Link
                component="a"
                href={documentoPDF}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: "#FFF", 
                  textDecoration: "none",
                  fontSize: "1.2rem", 
                  fontWeight: "medium",
                  '&:hover': {textDecoration:"underline"},
                  transition: 'all 0.2s'
                }}
              >
                {"Descargar"}
              </Link>
            </Box>
          </BoxDescarga>
        </Grid>

        {/* RECTÁNGULO AZUL */}
        <Grid item md={6} xs={12} sx={{ display: "flex" }}>
          <BoxDescarga 
            sx={{ 
              backgroundColor: "#2282E2",
              display: "flex",
              flexDirection: "column",
              p: 3,
              pt: 4,          // Misma altura de inicio que el rectángulo verde
              height: "100%", 
              width: "100%"
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center' }}>
              <Typography variant="cuerpo" color="#fff" sx={{ textAlign: 'center' }}>
                Por consultas técnicas y de sistema contactarse a los siguientes teléfonos 
              </Typography>
              <Typography variant="cuerpo" color="#fff" sx={{ mb: 3, textAlign: 'center' }}>
                Dirección General de Informática
              </Typography>
              
              <Box sx={{ 
                display: "grid", 
                gridTemplateColumns: "24px 1fr", 
                rowGap: 1.5,                  
                alignItems: "center",           
                width: "fit-content"            
              }}>
                <PhoneIcon sx={{ fontSize: "16px", color: "#fff", justifySelf: "center" }} />
                <Typography variant="cuerpo" color="#fff">0343 4208624</Typography>

                <PhoneIcon sx={{ fontSize: "16px", color: "#fff", justifySelf: "center" }} />
                <Typography variant="cuerpo" color="#fff">0343 4208649</Typography>

                <SmartphoneIcon sx={{ fontSize: "16px", color: "#fff", justifySelf: "center" }} />
                <Typography variant="cuerpo" color="#fff">+54 343 5176650</Typography>
              </Box> 
            </Box>
          </BoxDescarga>
        </Grid>

      </Grid>
    </Page>
  );
};

export default Inicio;
